export default "__VITE_ASSET__CzZf2k2X__"